import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from 'components/common/MaterialIcon';
import {Input, Select} from 'antd';
import uuidv1 from 'uuid/v1';
import Tools from './Tools';
import Item from './Item';

@autobind
/**
 *
 */
export default class Sortable extends React.PureComponent {
  static propTypes = {
    items: PropTypes.array,
    onChangeListItemInput: PropTypes.func,
    onChangeListItemSelect: PropTypes.func,
    onDeleteItem: PropTypes.func,
    onAdd: PropTypes.func,
    option: PropTypes.bool,
  };
  static defaultProps = {
    items: [],
    option: true,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
  }

  /**
   *
   */
  componentDidMount() {
    const {onSort} = this.props;
    $(function () {
      $('#sortable_signatory').sortable({
        update: function (event, ui) {
          let _update = [];
          $('.sortable_signatory').each(function (i) {
            $(this).data('id', i); // updates the data object
            $(this).attr('data-id', i); // updates the attribute
            _update.push($(this).attr('data-key'));
          });
          onSort(_update);
        },
      });
      $('#sortable_signatory').disableSelection();
    });
  }

  _renderItem(items) {
    let li = [];
    let _key = '';
    const {onChangeListItemInput, onChangeListItemSelect, onDeleteItem, option} = this.props;
    items.map((item, index) => {
      if (item.dataIndex && item.name) {
        _key = `${item.dataIndex}_${index}`;
        li.push(
          <Item
            key={_key}
            index={index}
            item={item}
            onChangeListItemInput={onChangeListItemInput}
            onChangeListItemSelect={onChangeListItemSelect}
            onDeleteItem={onDeleteItem}
            option={option}
          />,
        );
      }
    });
    return li;
  }


  /**
   *
   * @return {XML}
   */
  render() {
    const {items, onAdd} = this.props;
    return (
      <div>
        <Tools
          onAdd={onAdd}
        />
        <ul id="sortable_signatory">
          {this._renderItem(items)}
        </ul>
      </div>
    );
  }
}
